module.exports = __webpack_public_path__ + "media/images/trailer-54a33dbd6fdf5e4a2af492eaa734f77a.svg";